import { z } from 'zod'

export const userSettingResponseSchema = z.object({
  key: z.string(),
  value: z.unknown(),
})

export type UserSettingResponseDto = z.infer<typeof userSettingResponseSchema>
